module.exports = __webpack_public_path__ + "static/media/item_2_1_comp.22369183.png";